import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SortType} from "../../../commons/types/sort.type";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {TableColumnSizeType} from "../../../commons/types/table-column-size.type";

export class OmsOrdersTableController implements IController {

  columns?: any;
  dynamicColumns?: any;
  packageDynamicColumns?: any;
  infiniteScroll: any;
  selectedIds: [];
  excludeMode: boolean;
  sortExternalIdType: string;
  sortSchedulingSmsType: SortType;
  sortAccountReferenceNameType: string;
  sortCreatedAtType: string;
  sortSlaType: string;
  isScrollable: boolean;
  isAllowSelect: boolean;
  isAllowActions: boolean;
  isAllowSort: boolean;
  onSelectOrdersChanged: Function;
  onExternalIdSortTypeChange: Function;
  onSchedulingSmsSortTypeChange: Function;
  onAccountReferenceNameSortTypeChange: Function;
  onSlaSortTypeChange: Function;
  onSendToDispatch: Function;
  onCreatedAtSortTypeChange: Function;
  onFilterByType: Function;

  private asceDescIconsMap: any;
  private selectedKeys = undefined;
  private expandedKeys = {};

  constructor(private commonsConstants, private commonsService: CommonsService) {
  }

  $onInit() {
    this.asceDescIconsMap = this.commonsConstants.sortIconsMap;
    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.$onInit();
    }
    if (changes.excludeMode && !changes.excludeMode.isFirstChange()) {
      this.$onInit();
    }
  };

  $doCheck() {
    this.isScrollable = window.innerWidth < (this.commonsService.calculateTableColumnsTotalWidth(this.columns, this.dynamicColumns, this.commonsConstants.tableColumnSizes['small'] + 250));
  }

  onToggleExpand(orderId) {
    this.expandedKeys[orderId] = !this.expandedKeys[orderId];
  }

  onToggleSelectAll() {
    // this.selectedKeys = {};
    this.onSelectOrdersChanged({
      selectedIds: [],
      excludeMode: !this.excludeMode
    });
  }

  onToggleOrderSelect(order) {
    this.selectedKeys[order.id] = !this.selectedKeys[order.id];
    this.onSelectOrdersChanged({
      selectedIds: _.keys(_.pickBy(this.selectedKeys, _.identity)),
      excludeMode: this.excludeMode
    });
  }

  onToggleExternalIdSortType() {
    const sortType: SortType = this.sortExternalIdType ? (this.sortExternalIdType === SortType.asc ? SortType.desc : SortType.asc) : SortType.asc;
    this.onExternalIdSortTypeChange({sortType: sortType});
  }

  onToggleSchedulingSmsSortType() {
    const sortType: SortType = this.sortSchedulingSmsType ? (this.sortSchedulingSmsType === SortType.asc ? SortType.desc : SortType.asc) : SortType.asc;
    this.onSchedulingSmsSortTypeChange({sortType: sortType});
  }

  onToggleAccountReferenceNameSortType() {
    const sortType: SortType = this.sortAccountReferenceNameType ? (this.sortAccountReferenceNameType === SortType.asc ? SortType.desc : SortType.asc) : SortType.asc;
    this.onAccountReferenceNameSortTypeChange({sortType: sortType});
  }

  onToggleCeatedAtSortType() {
    const sortType: SortType = this.sortCreatedAtType ? (this.sortCreatedAtType === SortType.asc ? SortType.desc : SortType.asc) : SortType.asc;
    this.onCreatedAtSortTypeChange({sortType: sortType});
  }

  onToggleSlaSortType() {
    const sortType: SortType = this.sortSlaType ? (this.sortSlaType === SortType.asc ? SortType.desc : SortType.asc) : SortType.asc;
    this.onSlaSortTypeChange({sortType: sortType});
  }

  setEvents() {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }
}

angular
  .module('bringoz.admin.oms')
  .component('omsOrdersTable', {
    bindings: {
      columns: '<',
      dynamicColumns: '<?',
      packageDynamicColumns: '<?',
      infiniteScroll: '<',
      selectedIds: '<',
      excludeMode: '<',
      sortExternalIdType: '<',
      sortSchedulingSmsType: '<',
      sortSlaType: '<',
      sortAccountReferenceNameType: '<',
      sortCreatedAtType: '<',
      isScrollable: '<?',
      ordersCount: '<?',
      isAllowActions: '<?',
      isAllowSelect: '<?',
      isAllowSort: '<?',
      onSelectOrdersChanged: '&',
      onExternalIdSortTypeChange: '&',
      onSchedulingSmsSortTypeChange: '&',
      onAccountReferenceNameSortTypeChange: '&',
      onSlaSortTypeChange: '&',
      onCreatedAtSortTypeChange: '&',
      onAssign: '&',
      onSendToDispatch: '&',
      onFilterByType: '&'
    },
    template: require('./oms-orders-table.html').default,
    controller: OmsOrdersTableController
  });
